export default {
      id: "icon-update-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-update",
      toString: function () {
        return this.url;
      }
    }